import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-add\"><path d=\"M13 7.5H8.5V3h-1v4.5H3v1h4.5V13h1V8.5H13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol